import React, { useEffect, useRef, useState } from 'react';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { WebLinksAddon } from 'xterm-addon-web-links';
import { SearchAddon } from 'xterm-addon-search';
import { Unicode11Addon } from 'xterm-addon-unicode11';
import socketIOClient from 'socket.io-client';
// import { AttachAddon } from 'xterm-addon-attach';
import 'xterm/css/xterm.css';
import SpinnerCircles from '../Spinner/SpinerCircles';
import { dataCenterShellUrls } from '../EpikBoxes/BoxOverview';
import { useSelector } from 'react-redux';
import { ReactComponent as CrossIcon } from '../../Res/cross.svg';

function MyTerminal({ boxDetails,vpnAddress, usb, twoFaId, onCloseClick, increaseTerminalLife, setIncreaseTerminalLife, setTime, forceClose, did, usbTitle, usbLabel }) {
  const token = localStorage.getItem('jwtToken')
  const storeBox = useSelector(state => state?.AppState?.boxDetails?.box);
  const box = boxDetails ? boxDetails : storeBox
  const user = useSelector(state => state.AppState.user)
  const [socket, setSocket] = useState(null)
  const terminalRef = useRef(null);
  const terminal = useRef(null);
  const fitAddon = useRef(null);
  const webLinksAddon = useRef(null);
  const searchAddon = useRef(null);
  const unicode11Addon = useRef(null);
  // const attachAddon = useRef(null);

  const isConnected = useRef(false);
  const [loading, setLoading] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState('');

  const sendHeartbeat= (socket) => {
    setTimeout(() => sendHeartbeat(socket), 8000);
    socket.emit('ping', { box: box?.vpnAddress });
  }

  useEffect(() => {
    console.log('my terminal')
    let mounted = true;
    (async () => {
      // Try to fetch public IP to forward to backend
      let clientIp = null;
      try {
        const resp = await fetch('https://api.ipify.org?format=json');
        const data = await resp.json();
        clientIp = data?.ip || null;
      } catch (e) {
        console.log('Unable to resolve client IP', e);
      }

      if (!mounted) return;

      const url = dataCenterShellUrls[box.datacenter];
      const socket = socketIOClient.connect(url, {
        query: { token, 'x-forwarded-for': clientIp },
        transportOptions: {
          polling: {
            extraHeaders: clientIp ? { 'x-forwarded-for': clientIp } : {}
          }
        }
      });
      setSocket(socket);
      console.log('CONNECTION SOCKET');
      socket.on('connect', () => {
        console.log('Successfully connected!');
        socket.emit('PTY', {
          vpnAddress,
          usb,
          twoFaId,
          userId: user._id,
          serialNumber: box.serialNumber
        });
      });

      socket.on(`pty-${vpnAddress}-connection`, (data) => {
        console.log('ssh data ', data);
        setLoadingMsg(data.process);
        if (data.process === 'completed') {
          console.log('ssh completed ', data);

          isConnected.current = true;
          setLoading(false);
          setTimeout(() => initTerminal(socket), 100)
          sendHeartbeat(socket)
        }
      });

      return () => {};
    })();

    return () => {
      mounted = false;
      console.log("socket connection ended explicitly")
      if (socket) {
        socket.off(`pty-${vpnAddress}-connection`);
        socket.off(`pty-${vpnAddress}-response`)
        socket.off(`pty-${vpnAddress}-disconnect`)
        socket.close()
      }
    }
  }, [vpnAddress, usb, twoFaId, user._id, box.serialNumber, box.datacenter]);

  useEffect(() => {
    if (increaseTerminalLife) {
      socket.emit('PTY', {
        vpnAddress,
        'command': "\r",
        usb,
        twoFaId,
      });
      setIncreaseTerminalLife(false);
      setTime({ m: 4, s: 59 })
    }
  }, [increaseTerminalLife, socket, vpnAddress, usb, twoFaId, setIncreaseTerminalLife, setTime]);

  useEffect(() => {
    if (forceClose) {
      socket.off(`pty-${vpnAddress}-connection`);
      socket.off(`pty-${vpnAddress}-response`)
      socket.off(`pty-${vpnAddress}-disconnect`);
      onCloseClick()
      socket.close()
    }
  }, [forceClose, socket, vpnAddress, onCloseClick]);

  const initTerminal = (socket) => {
    terminal.current = new Terminal({ allowProposedApi: true, cursorBlink: true });
    fitAddon.current = new FitAddon();
    webLinksAddon.current = new WebLinksAddon();
    searchAddon.current = new SearchAddon();
    unicode11Addon.current = new Unicode11Addon();
    // attachAddon.current = new AttachAddon(new WebSocket('ws://localhost:3001'));

    terminal.current.loadAddon(fitAddon.current);
    terminal.current.loadAddon(webLinksAddon.current);
    terminal.current.loadAddon(searchAddon.current);
    terminal.current.loadAddon(unicode11Addon.current);
    // terminal.current.loadAddon(attachAddon.current);
    // current.on
    terminal.current.onData(data => {
      socket.emit('PTY', {
        vpnAddress,
        'command': data,
        usb,
        twoFaId,
      });
    });

    if (isConnected.current) {
      socket.on(`pty-${vpnAddress}-response`, data => {
        console.log({ remoteData: data });
        setTime({ m: 4, s: 59 })
        terminal.current.write(data.data);
      });

    }

    terminal.current.open(terminalRef.current);
    fitAddon.current.fit();

    socket.on(`pty-${vpnAddress}-disconnect`, () => {
      console.log('socket off')
      socket.off(`pty-${vpnAddress}-connection`);
      socket.off(`pty-${vpnAddress}-response`)
      onCloseClick()
      socket.close()
    })
  };

  return (
    <div className='custom-terminal'>
      {loading ? (
        <div className='custom-spinner-container'>
          <SpinnerCircles red />
          <span>{loadingMsg}</span>
        </div>
      ) : (
        <>
          <div className='oobm-termial-header'>
            <span>{`OOBM - WEB SSH Mode: ${did} | ${usbTitle}${usbLabel ? ` (${usbLabel})` : ''}`}</span>
            <CrossIcon width={17} height={17} style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => onCloseClick()} />
          </div>
          <div ref={terminalRef} style={{ width: '100%', height: '100%' }} />
        </>
      )}
    </div>
  );
}

export default MyTerminal;
